import React, { Component } from 'react'
import { Card, Button } from 'react-bootstrap'
import { INTERVALO_CORTO } from '../../../../../config/settings'
import { ToastContainer } from 'react-toastify'

class DialogoTareasDelete extends Component {
  render () {
    const {
      handleSubmit,
      handleClose
    } = this.props

    return (
      <div>
        <ToastContainer autoClose={INTERVALO_CORTO} />
        <Card style={{ border: 'none' }}>
          <Card.Body>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>Se eliminará la tarea de movimiento seleccionada.</Card.Text>                   </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button style={{ margin: '2%' }} onClick={handleClose} >Cancelar</Button>
            <Button style={{ margin: '2%' }} onClick={handleSubmit} >Confirmar</Button>
          </div>
        </Card>
      </div>
    )
  }
}

export default DialogoTareasDelete
